import classNames from "classnames";
import { type BorderRadius, Colors, type TextAlignment } from "schemas";
import { IconButton, bgStyles, borderStyles, flexStyles, iconStyles, paddingStyles, positionStyles } from "ui";
import { LinkButton } from "../../components/LinkButton";

interface Props {
  label: string;
  buttonTextColor: string;
  buttonBackgroundColor: string;
  buttonTextAlignment: TextAlignment;
  buttonBorderRadius: BorderRadius;
  onEdit: () => void;
}

const PageIconLight = "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/574e1f21-32d4-4dc3-4aa8-ef2389974c00/logo";
const PageIconDark = "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/168965c4-5d02-42f1-5a5a-dfe55e2b9b00/logo";

export function PageLinkBlock({
  label,
  buttonTextColor,
  buttonBackgroundColor,
  buttonBorderRadius,
  buttonTextAlignment,
  onEdit,
}: Props) {
  const iconSrc = buttonTextColor === Colors.Neutral0 ? PageIconLight : PageIconDark;
  return (
    <LinkButton
      href={"#"}
      iconSrc={iconSrc}
      buttonTextColor={buttonTextColor}
      buttonBackgroundColor={buttonBackgroundColor}
      buttonBorderRadius={buttonBorderRadius}
      buttonTextAlignment={buttonTextAlignment}
      extra={
        <div
          className={classNames(
            positionStyles.absolute,
            positionStyles.right050,
            positionStyles.top050,
            flexStyles.horiz050,
          )}
        >
          <IconButton
            className={classNames(
              bgStyles.neutral0,
              borderStyles.neutral200,
              positionStyles.zIndex5,
              paddingStyles.p075,
              iconStyles.neutral600,
            )}
            square
            iconType="Edit"
            onClick={() => onEdit()}
          />
        </div>
      }
    >
      <div
        style={{
          display: "inline-block",
          width: buttonTextAlignment === "Center" ? "auto" : "90%",
        }}
      >
        {label}
      </div>
    </LinkButton>
  );
}
